export const findObjectByKey = (data: any, key: string): any => {
  for (const obj of data) {
    if (obj.key === key) {
      return obj;
    } else if (obj.children && obj.children.length > 0) {
      const result = findObjectByKey(obj.children, key);
      if (result) {
        return result;
      }
    }
  }
  return null; // Key not found
};

export const formattedMoney = (amount: number): string => {
  return amount?.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};
